import { render, staticRenderFns } from "./exams.vue?vue&type=template&id=2e1e3dc3"
import script from "./exams.vue?vue&type=script&lang=js"
export * from "./exams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports